import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs';
import * as FileSaver from 'file-saver';
import {SummaryNotesData} from '../../../shared/types/nso-data-portal/dashboard-data';
import {share} from 'rxjs/operators';
import {
  OrganizationInformationRestService
} from '../../../shared/services/nso-data-portal/rest-services/organization-information-rest.service';
import {FileRestService} from '../../../shared/services/common/file/file-rest.service';
import {FileUtilsService} from '../../../shared/services/common/file/file-utils.service';

@Component({
  selector: 'wsd-summary-note',
  templateUrl: './summary-note.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./summary-note.component.css']
})
export class SummaryNoteComponent implements OnChanges {

  @Input()
  organizationId: number;

  showModal: boolean;

  summaryNotes$: Observable<SummaryNotesData>;

  constructor(private organizationService: OrganizationInformationRestService,
              private fileRestService: FileRestService,
              private fileUtils: FileUtilsService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.summaryNotes$ = this.organizationService.getSummaryNotes(this.organizationId)
      .pipe(share());
  }

  getSummaryNote(id: number) {
    this.fileRestService.getFile(id)
      .subscribe(
        (response: any) => FileSaver.saveAs(response.body, this.fileUtils.extractFileName(response)),
      );
  }

}
